export default __webpack_public_path__ + "ui/assets/img/block-20.svg";